import type { ReactNode } from "react";
import { type Capabilities, useCapabilities } from "@/features/account/useCurrentUser";
import { NotFoundPage } from "@/features/errors/NotFoundPage";

/** One capability, or a list where any one is enough. */
export type CapabilityRequirement = keyof Capabilities | readonly (keyof Capabilities)[];

export const hasCapability = (caps: Capabilities, needed: CapabilityRequirement) =>
  (typeof needed === "string" ? [needed] : needed).some((capability) => caps[capability]);

/** A capability-gated route: 404 when the deployment doesn't support it (the nav hides it too). */
export function RequireCapability({
  capability,
  children,
}: Readonly<{ capability: CapabilityRequirement; children: ReactNode }>) {
  return hasCapability(useCapabilities(), capability) ? children : <NotFoundPage />;
}
